import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import { ToastContainer, toast } from 'react-toastify'
import withAuth from '../components/authHOC'
import { Card, Col } from 'react-bootstrap'
import { Button, DatePicker, Form, Image, Input, Select } from 'antd'
import type { SelectProps } from 'antd'
import { IBranch, IClient, IGender, IIdType, IOccupation} from '../factory/interfaces'
import { AUTH_URL } from '../constants'
import axios from 'axios'
import { Upload } from 'antd'
import type {UploadFile} from 'antd'
import ImgCrop from 'antd-img-crop'
import { UploadOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'

export  const notify = (message: string, style: any) => toast.error(message, {
        style
        })
    //Toaster
export    const toastStyle: any =  {
        background: '#ffffff',
        color: '#0a0a0a',
        fontSize: "13px",
        padding: '2px',
        position: 'bottom-center',
        fontStyle: 'bold'
      }

export const notify_success = (message: string, style: any) => toast.success(message, {
        style
        })

export interface loginCredentials{
        email: string,
        password: string
    }

const getDistricts = (value: string, callback: Function) => {
  axios.post(`${AUTH_URL}/meta/districts/search`, {name: value}, {withCredentials: true})
    .then((response) => {
      const data = response.data.districts.map((district: any) => ({
        value: district._id,
        text: district.name,
      }));
      callback(data);
    })
    .catch((error) => {
      notify(`${error.message}`, toastStyle);
      callback([]);
    });
};

const NewClientPage = () => {

  const [client, setClient]= useState<IClient>()
  const [branches, setBranches]= useState<IBranch[]>()
  const [genders, setGenders]= useState<IGender[]>()
  const [occupations, setOccupations]= useState<IOccupation[]>()
  const [idTypes, setIdTypes]= useState<IIdType[]>()
  const [form] = Form.useForm()
  const [submitting, setSubmitting] = useState(false)
  const [data, setData] = useState<SelectProps['options']>([])
  const [value, setValue] = useState<string>()
  const [fileList, setFileList] = useState<any[]>([])

  ///Photoes

   const onPreview = async (file: UploadFile) => {
    let src = file.url as string;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj as any);
        reader.onload = () => resolve(reader.result as string);
      });
    }
    const image = document.createElement('img');
    image.src = src;

    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML)
  }
  const metadata = useSelector((state: any) => state.metadata)

  const handleSearch = (newValue: string) => {
    getDistricts(newValue, setData);
  };


    useEffect(() => {
    if (metadata?.data?.success) {
      setIdTypes(metadata.data.meta_data.id_types)
      setGenders(metadata.data.meta_data.genders)
      setOccupations(metadata.data.meta_data.occupations)
      setBranches(metadata.data.meta_data.branches)
    }
  }, [metadata])

  //Submit

 const submit = async (values: any) => {
  setSubmitting(true)
  const formData = new FormData();
  
  // Append the file to formData if it exists
  if (fileList.length > 0) {
    formData.append('photo', fileList[0].originFileObj);
  }

  if (fileList.length > 0 && client) {
  client.photo = fileList[0].originFileObj;
}

  // Append other form fields from client object
  if (client) {
    Object.keys(client).forEach((key: string) => {
      formData.append(key, (client as any)[key]);
    });
  }

  try {
    const response = await axios.post(`${AUTH_URL}/clients`, client, { withCredentials: true, headers: {
        'Content-Type': 'multipart/form-data',
      } }, 
    );
    setSubmitting(false);
    if (response.data.success) {
      notify_success('Client account has been created successfully', toastStyle);
      form.resetFields()
    } else {
      notify(`${response.data.message}`, toastStyle);
    }
  } catch (error: any) {
    notify(`${error.message}`, toastStyle);
  }
};


const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };


  return (
    <Container fluid id='users-container'>
        <Row className=' justify-content-center py-0 g-0'>
    <ToastContainer position="top-center" className='text-capitalize'/>
        </Row>
        <Row>
        <Col>
         <Card className='p-2 rounded-0'>
                <Form
                  className='p-3'
                  layout="vertical"
                  form={form}
                  name="control-hooks"
                  onFinish={submit}

                    >
                    <Row className='p-3  border'>
                    <h5>Personel details</h5>
                    <Col xs={12} md={2} style={{height: '100%'}}>
                    <Form.Item style={{height: '100%'}} label='Profile picture' name='photo' valuePropName='fileList' getValueFromEvent={normFile}>
                    
                      <ImgCrop rotationSlider  >
                        <Upload
                          listType="picture-card"
                          name='photo'
                          fileList={fileList}
                          onPreview={onPreview}
                          maxCount={1}
                          onChange={(info) => {
                            setFileList(info.fileList)
                          }}
                        >
                        {fileList.length < 1 && 
                        <><UploadOutlined/>Upload</>
                        }
                        </Upload>
                      </ImgCrop>
                    </Form.Item>
                    
                    </Col>
                    <Col>
                    <Row>
                    <Col>
                    <Form.Item 
                    label="Surname" 
                    rules={[{required: true, message: "Surname is required!"}]}
                    name="surname"
                    >
                        <Input 
                        onChange={(e) =>
                                setClient((prevUserData: any) => ({
                                    ...prevUserData,
                                    surname: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                    </Col>
                    <Col>
                    <Form.Item label="Given name"
                    rules={[{required: true, message: "Given name is required!"}]}
                    name="given_name"
                    >
                        <Input
                        onChange={(e) =>
                                setClient((prevUserData: any) => ({
                                    ...prevUserData,
                                    given_name: e.target.value,
                                }))
                            }  
                        />
                    </Form.Item>
                    
                    </Col>
                    <Col>

                    <Form.Item
                      label="Select Gender"
                      name="gender"
                      rules={[{ required: true, message: "Id type is required" }]}
                    >
                      <Select
                        allowClear
                        placeholder="Select gender"
                        style={{ width: '100%' }}
                        options={genders?.map((gender) => ({
                          value: gender._id,
                          label: gender.name,
                        }))}
                        onChange={(value) =>
                            setClient((prevUserData: any) => ({
                                ...prevUserData,
                                gender: value,
                            }))
                         }
                      />
                    </Form.Item>
                    
                    </Col>
                    
                    </Row>
                     <Row>
                    <Col>
                      <Form.Item
                      label="Date of birth"
                      name="date_of_birth"
                      rules={[{ required: true, message: "Date of birth is required" }]}
                    >
                      <DatePicker
                      style={{width: '100%'}} 
                      onChange={(date, dateString) =>
                                setClient((prevUserData: any) => ({
                                    ...prevUserData,
                                    date_of_birth: dateString,
                                }))
                            }  
                      className='rounded-0'
                      />
                    </Form.Item>
                    </Col>
                    <Col>
                     <Form.Item 
                      label="Phone"
                      rules={[{required: true, message: "Phone number is required!"}]}
                      name="phone"
                      >
                        <Input
                          placeholder='E.g. 0782531813'
                          onChange={(e) =>
                                setClient((prevUserData: any) => ({
                                    ...prevUserData,
                                    phone: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                    

                    </Col>
                    <Col>
                    <Form.Item 
                    label="Email"
                    rules={[{required: false, message: "Email is required!"}]}
                    name="email"
                    >
                        <Input 
                          onChange={(e) =>
                                setClient((prevUserData: any) => ({
                                    ...prevUserData,
                                    email: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                   
                    
                    </Col>
                    
                    </Row>
                    <Row>
                    <Col>
                      <Form.Item
                      label="Choose Id type"
                      name="id_type"
                      rules={[{ required: true, message: "Id type is required" }]}
                    >
                      <Select
                        allowClear
                        placeholder="Select ID type"
                        style={{ width: '100%' }}
                        options={idTypes?.map((type) => ({
                          value: type._id,
                          label: type.name,
                        }))}
                        onChange={(value) =>
                            setClient((prevUserData: any) => ({
                                ...prevUserData,
                                id_type: value,
                            }))
                         }
                      />
                    </Form.Item>
                    
                    
                    </Col>
                    <Col>
                     <Form.Item 
                    label="ID Number"
                    rules={[{required: true, message: "Id Number is required!"}]}
                    name="id_number"
                    >
                        <Input 
                          onChange={(e) =>
                                setClient((prevUserData: any) => ({
                                    ...prevUserData,
                                    id_number: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                    <Form.Item
                      label="Select branch"
                      name="branch"
                      rules={[{ required: true, message: "User must belong to a branch!" }]}
                    >
                      <Select
                        allowClear
                        placeholder="Select branch name"
                        style={{ width: '100%' }}
                        options={branches?.map((branch) => ({
                          value: branch._id,
                          label: branch.name,
                        }))}
                        onChange={(value) =>
                            setClient((prevUserData: any) => ({
                                ...prevUserData,
                                branch: value,
                            }))
                         }
                      />
                    </Form.Item>                    
                    </Col>
                    
                    </Row>
                    <Row>
                    <Col>
                    <Form.Item
                      label="Select client category"
                      name="category"
                      rules={[{ required: true, message: "Client category is required" }]}
                      tooltip='NEW is for the new clients. CONTINUING are those that have active loans but not digitally registered on this system. DEFAULTER is a client who defaulted and was not registered in the system.'

                    >
                      <Select
                        allowClear
                        placeholder="Client category"
                        style={{ width: '100%' }}
                        options={[
                            { value: 'NEW', label: 'NEW' },
                            { value: 'CONTINUING', label: 'CONTINUING' },
                            { value: 'DEFAULTER', label: 'DEFAULTER' }
                          ]}
                        onChange={(value) =>
                            setClient((prevUserData: any) => ({
                                ...prevUserData,
                                category: value,
                            }))
                         }
                      />
                    </Form.Item>
                    </Col>
                    <Col></Col>
                    <Col></Col>
                    </Row>
                    </Col>
                    </Row>
                    <Row className='p-3 my-3 border'>
                    <h5>Address details</h5>
                    <Row>
                    <Col>
                    <Form.Item 
                      label="District" 
                      rules={[{required: true, message: "District is required!"}]}
                      name="district"
                      >
                      <Select
                        showSearch
                        value={value}
                        defaultActiveFirstOption={false}
                        suffixIcon={null}
                        filterOption={false}
                        onSearch={handleSearch}
                        onChange={(value) =>
                            setClient((prevUserData: any) => ({
                                ...prevUserData,
                                district: value,
                            }))
                         }
                        notFoundContent={null}
                        options={(data || []).map((d) => ({
                          value: d.value,
                          label: d.text,
                        }))}
                      />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                     <Form.Item label="Subcounty"
                    rules={[{required: true, message: "Subcounty is required!"}]}
                    name="sub_county"
                    >
                        <Input
                        onChange={(e) =>
                                setClient((prevUserData: any) => ({
                                    ...prevUserData,
                                    sub_county: e.target.value,
                                }))
                            }  
                        />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                    <Form.Item 
                    label="Village" 
                    rules={[{required: true, message: "Village is required!"}]}
                    name="village"
                    >
                        <Input 
                        onChange={(e) =>
                                setClient((prevUserData: any) => ({
                                    ...prevUserData,
                                    village: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                    </Col>
              
                    
                    </Row>
                    <Row>
                      <Col>
                      <Form.Item
                      label="Chairperson's name"
                      rules={[{ required: true, message: "Chairman's name is required!" }]}
                      name="chairman_name"
                    >
                      <Input
                        onChange={(e) =>
                          setClient((prevUserData: any) => ({
                            ...prevUserData,
                            chairman: {
                              ...prevUserData.chairman,
                              name: e.target.value,
                            },
                          }))
                        }
                      />
                    </Form.Item>
                    </Col>
                    <Col>
                    <Form.Item
                      label="Chairperson's phone number"
                      rules={[{ required: true, message: "Chairman's phone number is required!" }]}
                      name="chairman_phone"
                    >
                      <Input
                        onChange={(e) =>
                          setClient((prevUserData: any) => ({
                            ...prevUserData,
                            chairman: {
                              ...prevUserData.chairman,
                              phone: e.target.value,
                            },
                          }))
                        }
                      />
                    </Form.Item>
                    </Col>
                    </Row>
                    </Row>
                     <Row className='p-3 my-3 border'>
                    <h5>Employment/Occupation details</h5>
                    <Col>
                     <Form.Item
                      label="Select occupation"
                      name="occupation"
                      rules={[{ required: true, message: "Occupation is required" }]}
                    >
                      <Select
                        allowClear
                        placeholder="Select Occupation"
                        style={{ width: '100%' }}
                        options={occupations?.map((occ) => ({
                          value: occ._id,
                          label: occ.name,
                        }))}
                        onChange={(value) =>
                            setClient((prevUserData: any) => ({
                                ...prevUserData,
                                occupation: value,
                            }))
                         }
                      />
                    </Form.Item>
                    <Form.Item label="Employer/Company name"
                    name="employer_name"
                    >
                        <Input
                        onChange={(e) =>
                                setClient((prevUserData: any) => ({
                                    ...prevUserData,
                                     employer: {
                                    ...prevUserData.employer,
                                    name: e.target.value,
                                  },
                                }))
                            }  
                        />
                    </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item label="Employer/Company phone"
                      name="employer_phone"
                      >
                          <Input
                          onChange={(e) =>
                                  setClient((prevUserData: any) => ({
                                      ...prevUserData,
                                      employer: {
                                      ...prevUserData.employer,
                                      phone: e.target.value,
                                    },
                                  }))
                              }  
                          />
                      </Form.Item>
                      <Form.Item label="Employer/Company address"
                        name="employer_address"
                        >
                            <Input
                            onChange={(e) =>
                                    setClient((prevUserData: any) => ({
                                        ...prevUserData,
                                        employer: {
                                        ...prevUserData.employer,
                                        address: e.target.value,
                                      },
                                    }))
                                }  
                            />
                      </Form.Item>
                  
                    </Col>
                    </Row>
                    <Row>
                    <Col>
                    <Button
                      loading={submitting} 
                      type="primary" 
                      htmlType="submit" 
                      className='rounded-0 text-uppercase'
                      >
                      {

                        submitting ?
                      'Registering client...' :
                      'Register Client'
                      }
      
                     </Button>
                    
                    </Col>
                     
                    </Row>
                  
                </Form>
            </Card>
        
        
        </Col>
        
        </Row>
    </Container>
  )
}

export default withAuth (NewClientPage, ['admin', 'agent'])
